export default __webpack_public_path__ + "static/media/Prabu.1979370f.png";